// https://vuex.vuejs.org/en/mutations.html

export default {
    setEventCard(state, payload) {
        state.eventCard = payload
    },
    setHallPlan(state, payload) {
        state.hallPlan = payload
    },
}
